import clsx from "clsx";
import { useRef } from "react";
import { useToggleState } from "react-stately";
import { useCheckbox, AriaCheckboxProps } from "react-aria";
import { CheckIcon } from "@heroicons/react/16/solid";

interface CheckboxProps extends AriaCheckboxProps {
    children: React.ReactNode;
    className?: string;
}

function CheckboxSmall(props: CheckboxProps) {
    const { children, className } = props;
    const state = useToggleState(props);
    const ref = useRef<HTMLInputElement>(null);
    const { inputProps } = useCheckbox(props, state, ref);

    const checkboxClass = clsx(
        "w-4 h-4 text-white rounded",
        state.isSelected
            ? "bg-stone-vibrant"
            : "bg-white border border-stone-vibrant"
    );

    return (
        <label className={`checkbox cursor-pointer relative items-center text-label text-foreground-dark ${className}`}>
            <input {...inputProps} ref={ref} />
            <span className="z-0">
                <CheckIcon className={checkboxClass} />
            </span>
            {children}
        </label>
    );
}

export default CheckboxSmall;
